interface Props {
  readonly size?: number;
  readonly className?: string;
}

export default function CodeSamplesIcon(props: Props) {
  const { size = 17, className } = props;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="m6.37 16.5-.01-2c-2.97.65-3.59-1.27-3.59-1.27-.47-1.25-1.18-1.57-1.18-1.57-.97-.66.07-.66.07-.66 1.08.07 1.64 1.1 1.64 1.1.96 1.64 2.5 1.18 3.11.9.09-.7.37-1.18.67-1.45-2.37-.24-4.86-1.17-4.86-5.3a4.2 4.2 0 0 1 1.1-2.88 3.9 3.9 0 0 1 .1-2.85s.9-.28 2.94 1.1a10.25 10.25 0 0 1 5.33 0C13.72.25 14.62.53 14.62.53a3.9 3.9 0 0 1 .1 2.85c.7.75 1.1 1.7 1.1 2.88 0 4.13-2.49 5.04-4.87 5.3.39.34.72.98.72 2l-.02 2.95"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
